<template>
    <div class="manage-table relative flex flex-col w-full h-full bg-white rounded overflow-hidden">
        <div class="manage-table-header hidden xl:flex xl:justify-between xl:items-center px-4 py-2 bg-white">
            <slot name="header" />
        </div>
        <div class="manage-table-body relative flex-1 flex flex-col overflow-auto">
            <template v-if="list">
                <template v-if="list.length">
                    <div
                        v-for="(item, index) in list"
                        :key="index"
                        class="manage-table-item flex flex-col xl:flex-row justify-between xl:items-center w-full p-4 bg-white"
                    >
                        <slot :item="item" :index="item" />
                    </div>
                </template>
                <div v-else class="manage-table-empty absolute pin-t pin-l w-full h-full">
                    <slot name="empty" />
                </div>
            </template>

            <div v-if="!list || loading" class="manage-table-loading absolute pin-t pin-l w-full h-full">
                <slot name="loading" />
            </div>
        </div>
        <div
            v-if="paginator && list && list.length"
            class="manage-table-footer flex justify-center items-center bg-white"
        >
            <Paginator
                @pagination-change="$emit('pagination-change', $event)"
                :current-page="Number(currentPage)"
                :page-count="Number(pageCount)"
                :total-items="Number(totalItems)"
                :disabled="disablePagination"
                :items-per-page="Number(itemsPerPage)"
            />
        </div>
    </div>
</template>

<script>
import Paginator from '@/components/Paginator'

export default {
    components: {
        Paginator
    },

    props: {
        list: {
            type: Array,
            default: () => null
        },

        currentPage: {
            type: [Number, String],
            default: 1
        },

        pageCount: {
            type: [Number, String],
            default: 0
        },

        itemsPerPage: {
            type: [Number, String],
            default: 25
        },

        totalItems: {
            type: [Number, String],
            default: 0
        },

        loading: {
            type: Boolean,
            default: false
        },

        disablePagination: {
            type: Boolean,
            default: false
        },

        paginator: {
            type: Boolean,
            default: true
        }
    }
}
</script>

<style lang="scss">
.manage-table {
    border: 1px solid #ced4da;
    color: #333;

    .manage-table-header {
        height: 3rem;
        background-color: #f3f3f3;
        border-bottom: 1px solid #ced4da;
    }

    .manage-table-body {
        &::-webkit-scrollbar {
            width: 0;
            height: 0;
        }

        .manage-table-item {
            border-bottom: 1px solid #ced4da;
        }

        .manage-table-empty {
            font-size: 1rem;

            @media screen and (min-width: 1200px) {
                font-size: 1.125rem;
            }

            i {
                font-size: 3rem;

                @media screen and (min-width: 1200px) {
                    font-size: 3.5rem;
                }
            }
        }
    }

    .manage-table-footer {
        width: 100%;
        height: 3.5rem;
        background-color: #f3f3f3;
        border-top: 1px solid #ced4da;
    }
}
</style>